import { SecurityMasterPatcher } from './security-master-patcher.cls';
/**
 *
 */
export var NSPatchers = {
    SecurityMasterPatcher: SecurityMasterPatcher
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/patcher/index.ts
// module id = null
// module chunks = 